import { useAuth } from "@/contexts/AuthContext";
import { useStore } from "@/contexts/StoreContext";
import { useSettings } from "@/contexts/SettingsContext";
import { isPaidAccess } from "@/lib/plan";
import type { NavAccess } from "@/components/dashboard/nav-config";

export function useNavAccess(): NavAccess {
  const { user, currentStore } = useAuth();
  const { hasPermission } = useStore();
  const { bookingSettings } = useSettings();

  return {
    hasPermission,
    isOwner: currentStore?.isOwner === true,
    isPaid: isPaidAccess(user),
    bookingsEnabled: Boolean(bookingSettings?.enabled),
    isSuperadmin: user?.role === "superadmin",
  };
}
